module.exports = __webpack_public_path__ + "img/C4.ef6edffc.jpg";